<script>
export default {
  name: "CandidateCard",
  props: ["candidate"],
  computed: {
    cityName() {

      if(this.candidate.commune.name) {
        return this.candidate.commune.name;
      } else {
        return this.candidate.commune.externalCommune;
      }
    },
    candidateUrl() {
      return `/elections/${this.candidate.election.id}/candidates/${this.candidate.id}`;
    },
    position() {
      if(!this.candidate.election.complete) {
        if (this.candidate.currentlyActing) {
          return `${this.candidate.position} (Amtsinhaber${this.candidate.person.gender === 'f' ? 'in' : ''})`;
        } else {
          return `Für das Amt des ${this.candidate.position}s`;
        }
      }

      if(this.candidate.elected) {
        if(this.candidate.person.gender === 'f') {
          if(this.candidate.position === 'Landrat') {
            return 'Landrätin';
          } else if(this.candidate.position === 'Bürgermeister') {
            return 'Bürgermeisterin';
          }
        }
      }
      else {
        return `Für das Amt des ${this.candidate.position}s`;
      }

        return this.candidate.position;
    }
  }
}
</script>

<template>
  <router-link :to="candidateUrl">
<v-sheet class="candidate-card">
  <div class="header pr">
    <template v-if="candidate.election.complete">
      <span class="candidate-badge elected-badge" v-if="candidate.elected">Gewählt</span>
      <span class="candidate-badge" v-else>Nicht gewählt</span>
    </template>
    <template v-else>
       <span class="candidate-badge acting-badge">Kandidat/in</span>
    </template>

    <span class="party-name">{{ candidate.party.name}}</span>
  </div>
  <div class="name pr">
    {{ candidate.person.name }}
  </div>
  <div class="position pr">
    {{ position }}
  </div>
  <div class="commune pr">
    {{ cityName }}
  </div>
  <div class="footer">
    <span class="election-info">{{ candidate.election.type }}</span>
    <router-link :to="candidateUrl" class="detail-link">
      <v-icon color="primary">mdi-arrow-right</v-icon>
    </router-link>
  </div>
</v-sheet>
  </router-link>
</template>

<style scoped>
.candidate-card {
  padding: 16px;
  padding-bottom: 0;
  padding-right: 0px;
  border-radius: 5px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  margin-bottom: 16px;
}

*:hover {
  text-decoration: none !important;
}
.pr {
  padding-right: 16px;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.party-name {
  font-size: 16px;
  font-family: "GeometriaMedium", sans-serif;
}

.name {
  font-size: 20px;
  font-family: "GeometriaMedium", sans-serif;
}

.footer {
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.election-info {
  font-size: 12px;
  font-family: "GeometriaMedium", sans-serif;
}

.detail-link {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #F2F2F3 0% 0% no-repeat padding-box;
  border-radius: 0px 0px 5px 0px;
}

.detail-link:hover {
  text-decoration: none !important;
}
</style>